module.exports = __webpack_public_path__ + "static/media/info-icon.e048d6ba.svg";